/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import Header from '../directives/header'
import Footer from '../directives/footer'
import 'react-accessible-accordion/dist/fancy-example.css';


const Howtocreaterig = () => {


    return (

        <>
            <Header />
            <div id="content" className="">
                <div className="breadcrumb-wrap bg-f br-4" style={{backgroundImage:"url(images/create_a_rig.png)"}}>
                    <div className="overlay bg-black op-7" />
                    <div className="container">
                        <div className="breadcrumb-title">
                            <h3>How to Create a rig ?</h3>
                            <ul className="breadcrumb-menu list-style">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>How to Create a Rig</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='container mb-3'>

                    <br />
                    <h4  className='mt-3 mb-3'>Help Guide -</h4>
                    <ul style={{paddingLeft:"20px"}}>
                        <li className='mt-2'>Step 1. Go on to the NFT Dashboard.</li>
                        <li className='mt-2'>Step 2. Click on My Rig from the sidebar menu.</li>
                        <li className='mt-2'>Step 3. An “Assemble Rig” option will appear in the center of the screen. Click on that option.</li>
                        <li className='mt-2'>Step 4. You can now select from 3 categories of Rigs as per your choice: GEN X,  GENY,  GEN Z.</li>
                        <li className='mt-2'>Step 5. If you have all the required NFTs for the selected Rig Generation, you can proceed to the next level. </li>
                        <li className='mt-2'>Step 6. If you do not have all the required NFTs for the selected Rig Generation, No worries Hop on to the NFT Marketplace and Purchase them. </li>
                        <li className='mt-2'>Step 7. Rig Creation will charge some MNTs as a Rig Creation Fee. </li>
                        <li className='mt-2'>Step 8. It’s the time to bring your Rig to life! Click on Start Assembling.</li>
                        <li className='mt-2'>Step 9. Now you can see your Assembled Rig in the My Rig Page.</li>
                        <li className='mt-2'>Step 10. Hurray! you may now see the rewards points on the Rig History Section of the Minting Rewards Page.</li>
                    </ul>
                    <br/>

<h4>Advantage -</h4> 

<li className='mt-2' style={{paddingLeft:"20px"}}>You will receive double Hash Power for all NFTs used in the Rig Creation</li>
<br/>
                    {/* <p>
                        Welcome to theEurotron Blockchain Pvt Ltdprivacy notice. Eurotron Blockchain
                        Pvt Ltdrespects your privacyand is committed to protect your personal data.
                        This privacy notice informs you abouthow we care about your personal
                        information when you:
                    </p>
                    <ul>
                        <li>
                            visit our website https://mrmint.io/ or domains (collectively “Website”)
                        </li>
                        <li>
                            complete surveys and subscribe to the newsletters, communicate with our
                            team (“Voluntary provision of data”); and/or use our services and tell you
                            about your privacy rightsand how the law protects you.
                        </li>
                    </ul>
                    <p />
                    <br />
                    <h4>IMPORTANT INFORMATION AND WHO WE ARE</h4>
                    <h4>1. Purpose of this privacy notice</h4>
                    <p>
                        This privacy notice aims to give you information on how Eurotron Blockchain
                        Pvt Ltdcollects and processes your personal data through your use of the
                        Website and/or Services and/or Voluntary provision of data, including any
                        data you may provide and/or we may collect through your use of the Website,
                        the Services and/or when you sign up to our newsletters, complete our
                        surveys and/or communicate with our support service. It is important that
                        you read this privacy notice in conjunction with any other privacy or fair
                        handling notice that we may provide in certain cases where we collect or
                        process personal data about you, so that you are fully aware of how and why
                        we use your data. This privacy notice is in addition to the other notices
                        and is not intended to cancel them. 2. Changes to the privacy notice and
                        your duty to inform us about them This version was last updated on
                        28/04/2022. We may update this Privacy policy from time to time. The updated
                        version will be indicated by the date of the last update above. If we make
                        material changes to this privacy policy, we may notify you by posting a
                        notice on the website and / or the Services, or by sending a notice directly
                        to you. We encourage you to review this privacy policy frequently to be
                        informed of how we are protecting your information.
                    </p>
                    <br />
                    <h4>3. The data we collect about you</h4>
                    <p>
                        Personal data or personal information means any information about a person
                        by which that person can be identified. It does not include data whose
                        identity has been deleted (anonymous data). We may collect, use, store and
                        transfer different kinds of personal data about you which we have grouped
                        together as follows. Information You Give Us: This is your personal
                        information that you give us by filling the forms or by corresponding with
                        us by post, phone, and email or otherwise. This includes personal data you
                        enter on our Website, provide to us through the Services or through means of
                        Voluntary provision of data or give us in any other way. You provide such
                        information when you:
                    </p>
                    <ul>
                        <li>use our Website and Services</li>
                        <li>fill the forms and inquiries</li>
                        <li>subscribe to our newsletters</li>
                        <li>fill out a survey</li>
                        <li>
                            participate in (sign up to) any contest, promotional activity, giveaway,
                            events, education, career, partnership offers
                        </li>
                        <li>
                            communicate with our support service, give us feedback (for example, when
                            you communicate with us by customer support form, e-mail, phone, mail or
                            otherwise).
                        </li>
                    </ul>
                    <br />
                    <p>
                        As a result of those actions, you might supply us with such information as
                        your name,address, e-mail, phone number, information regarding your
                        wallet(s) and the crypto tokens you have, and other data. Automatic
                        Collection of Information: We receive and store certain types of
                        informationautomatically whenever you interact with us. As you interact with
                        our Website and/orServices, we may automatically collect technical data
                        about your equipment, browserfeatures, browsing actions and patterns. For
                        example, like many websites, at the Website and Services we use “cookies’’
                        and other similar tools and identifiers for analyticsand marketing (like web
                        beacons and pixels), and we obtain certain types of informationwhen you
                        access our Website and/or our Services (access log records such as date,
                        IPaddress, user agent). However, aggregated data is not considered personal
                        data, as thisdata does not directly or indirectly reveal your identity. For
                        example, we may aggregate your Usage Data to calculate the percentage of
                        users accessing a specific websitefeature. Information from Other Sources:
                        We might receive information about you fromother sources (such as public
                        databases, marketing partners and other third parties) andadd it to our
                        account information (this concerns technical data from the following
                        parties: analytics providers such as Google; advertising networks; and
                        search informationproviders). We will inform you about the source of
                        information and the type of information we have collected about you within a
                        reasonable period after obtaining the personal data, but at the latest
                        within a month. We do not collect any Special Categories of Personal Data
                        about you (this includes details about your race or ethnicity, religious or
                        philosophical beliefs, sex life, sexual orientation, political opinions,
                        trade union membership, information about your health and genetic and
                        biometric data). Nor do we collect any information about criminal
                        convictions and offences.
                    </p>
                    <br />
                    <h4>4. How we use your personal data</h4>
                    <p>
                        We will only use your personal data when the law allows us to. Most
                        commonly, we will use your personal data in the following circumstances:
                        <br />
                    </p>
                    <ul>
                        <li>
                            Your consent. We may process your data when you consented for the use of
                            such data by us
                        </li>
                        <li>
                            Legitimate Interests. We may process your data where it is necessary for
                            our legitimate interests (or those of a third party) and your interests
                            and fundamental rights do not override them. For instance, for provision
                            of Website and Services to you, for the development of business, to
                            procure compliance with our terms and policies
                        </li>
                        <li>
                            Legal obligation. Where we need to comply with a legal or regulatory
                            obligation (for example, to comply with applicable law, governmental
                            requests, a judicial proceeding, court order, legal process, and
                            enforcement requirements). We may also disclose your information where it
                            is necessary to investigate, prevent or take action regarding potential or
                            suspected fraud, illegal activities, and situations involving potential
                            threats to safety. Please note that we may process your personal data
                            without your knowledge or consent, in compliance with the above rules,
                            where this is required or permitted by law.
                        </li>
                    </ul>
                    <p />
                    <br />
                    <h4>5. Change of purpose</h4>
                    <p>
                        We will only use your personal data for the purposes for which we collected
                        it, unless we reasonably consider that we need to use it for a reason
                        compatible with the original purpose. If we need to use your personal data
                        for a purpose not related to the purposes stipulated here, we will notify
                        you and we will explain the legal basis which allows us to do so.
                    </p>
                    <br />
                    <h4>6. Disclosures of your personal data</h4>
                    <p>
                        We may have to share your personal data with the parties set out below for
                        the purposes set out in the table in paragraph 4 above. Third Party Service
                        Providers We may share your data with third party vendors, service
                        providers, contractors or agents who perform services for us or on our
                        behalf and require access to such information to perform such work (for
                        example, for development and technical support and maintenance of the
                        Website and Services, organizing of promotional and marketing activities,
                        data analysis, email delivery, hosting services, customer service). Business
                        Transfers Third Parties to whom we may choose to sell, transfer, or merge
                        parts of our business or our assets. Alternatively, we may seek to acquire
                        other businesses or merge with them. If a change happens to our business,
                        then the new owners may use your personal data in the same way as set out in
                        this privacy notice. Affiliates? We may share your information with our
                        affiliates (including parties that we control controlled by or under common
                        control with us).We require all third parties to respect the security of
                        your personal data and to treat it inaccordance with the law and this
                        Privacy Policy. We do not allow our third-party serviceproviders to use your
                        personal data for their own purposes, share it with third partiesand only
                        permit them to process your personal data for specified purposes and in
                        accordance with our instructions.
                    </p>
                    <br />
                    <h4>7. International transfers</h4>
                    <p>
                        Please note that your information may be transferred, stored and processed
                        by us and by those third parties with whom we may share your information in
                        various countries, including outside the United Kingdom. These countries may
                        have less stringent privacy laws than we do, so any information they hold
                        can become subject to their laws and disclosure requirements, including
                        disclosure to governmental bodies, regulatory agencies and private persons.
                        In addition, a number of countries have agreements under which information
                        is exchanged with other countries for law enforcement, tax and other
                        purposes. We will however take all necessary measures to protect your
                        personal information in accordance with this Privacy policy and applicable
                        law and require all our contractors to follow the same rules when processing
                        your personal data.
                    </p>
                    <br />
                    <h4>8. Data security</h4>
                    <p>
                        We have put in place appropriate technical and organizational security
                        measures to prevent your personal data from being accidentally lost, used or
                        accessed in an unauthorized way, altered or disclosed. In addition, we limit
                        access to your personal data to those employees, agents, contractors and
                        other third parties. They will only process your personal data on our
                        instructions and they are subject to a duty of confidentiality. We have put
                        in place procedures to deal with any suspected personal data breach and will
                        notify you and any applicable regulator of a breach where we are legally
                        required to do so. However, please remember that the transmission of data
                        over the Internet (including e-mail) is never completely secure. Therefore,
                        while we use appropriate measures to try to protect your personal data, we
                        cannot guarantee the security of the data transmitted to us or by us. You
                        must access the Website and Services and / or otherwise transmit your data
                        in a secure environment.
                    </p>
                    <br />
                    <h4>9. Data retention</h4>
                    <p>
                        We will only retain your personal data for as long as is necessary to
                        achieve the purposes for which we collected it, unless a longer retention
                        period is required or permitted by law (for example, any legal, accounting
                        or reporting requirements). When we do not have an ongoing legitimate
                        business need to process your personal information, we will either delete it
                        or anonymize it, or, if this is not possible (for example, if your data is
                        stored in backup systems), we will securely store it until it is deletedIf
                        in some circumstances we anonymize your personal data (so that they can no
                        longer be associated with you) for research or statistical purposes, in
                        which case we may use this information indefinitely without further notice.
                    </p>
                    <br />
                    <h4>10. Your legal rights</h4>
                    <p>
                        Under certain circumstances, you have the following rights under data
                        protection laws in relation to your personal data:
                    </p>
                    <li>request access to your personal data</li>
                    <li>request correction of your personal data</li>
                    <li>request erasure of your personal data</li>
                    <li>object to or restrict processing of your personal data</li>
                    <li>request restriction of processing your personal data</li>
                    <li>request transfer of your personal data (data portability)</li>
                    <li>
                        right to withdraw consent If we are relying on your consent to process your
                        personal data you have the right to withdraw your consent at any time.
                        However, this will not affect the lawfulness of any processing carried out
                        before you withdraw your consent. If you withdraw your consent, we may not
                        be able to provide you with certain services. We will inform you about it
                        when you withdraw your consent. Please note that under certain circumstances
                        it may be lawful for us to continue processing your information even if you
                        have withdrawn your consent if one of the other legal grounds applies. No
                        fee usually required. You will not have to pay a fee to access your personal
                        data (or to exercise any of the other rights).
                        <p />
                        <br />
                        <h4>11. Third-party links</h4>
                        <p>
                            The Website, Services and means of Voluntary provision of data may include
                            links to third-party websites and services, plug-ins and applications.
                            Clicking on those links or enabling those connections may allow third
                            parties to collect or share data about you. We do not control these
                            third-party websites and services and are not responsible for their
                            privacy statements. When you leave the Website and/or Services and/or use
                            means of Voluntary provision of data ran/built on or hosted by third-party
                            services, we encourage you to read the privacy notice of every third-party
                            website and service you visit.
                        </p>
                        <br />
                        <h4>12. Cookies</h4>
                        <p>
                            We may use cookies and similar tracking technologies (like web beacons and
                            pixels)to access and store information. You can set your browser to refuse
                            all or some browser cookies, or to alert you when the Website or Services
                            set or access cookies. If youdisable or refuse cookies, please note that
                            some parts of the Website or Services maybecome inaccessible or not
                            function properly.
                        </p>
                        <br />
                        <h4>13. Contact us</h4>
                        <p>
                            If you have questions or comments about this Privacy Policy or the
                            handling of your personal data by us, email us at: support@mrmint.io
                        </p>
                        <p></p>
                    </li> */}


                    <br />
                </div>




            </div>
            <Footer />
        </>

    )

}
export default Howtocreaterig;